import {
    selectors,
    findChosenInsuranceRadio
} from './shared';

const VIEW_ITEM_LIST_INSURANCE_EVENT = 'view_item_list_insurance';
const VIEW_ITEM_INSURANCE_EVENT = 'view_item_insurance';
const UPDATE_CART_EVENT = 'update_cart';
const REMOVE_CART_EVENT = 'remove_from_cart';
const DATA_INSURANCE_ITEM = 'data-analytic-insurance-item';

const sendData = (event, items) => {
    if (items.length === 0) {
        return;
    }
    const isTradedIn = document.querySelector('[data-analytic-trade-in]');
    if (isTradedIn && event == UPDATE_CART_EVENT) {
        dataLayer.push({
            event: event,
            'trade-in': isTradedIn.getAttribute('data-analytic-trade-in'),
            items: items,
        });
    } else {
        dataLayer.push({
            event: event,
            items: items,
        });
    }
};

export const triggerViewItemListInsuranceEvent = () => {
    window.addEventListener('load', () => {
        const hasExtrasComponent = document.querySelector('[data-insurance-component]');
        const isBasketPage = document.querySelector('.basket-no-insurance');
        if (!hasExtrasComponent || isBasketPage) {
            return;
        }
        const itemDataArray = [];
        document.querySelectorAll(selectors.component).forEach((insuranceComponent) => {
            const chosenInsuranceRadio = findChosenInsuranceRadio(insuranceComponent);
            if (chosenInsuranceRadio && chosenInsuranceRadio.value !== 'no') {
                return;
            }
            const item = JSON.parse(
                insuranceComponent.getAttribute(DATA_INSURANCE_ITEM)
            );
            itemDataArray.push(item);
        });
        sendData(VIEW_ITEM_LIST_INSURANCE_EVENT, itemDataArray);
    });
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-action="add-insurance"]');
        if (!btn) {
            return;
        }
        const isNoInsuranceBlock = btn.closest('.basket-no-insurance');
        if (!isNoInsuranceBlock) {
            return;
        }
        const basketLineId = btn.getAttribute('data-basket-line-id');
        const itemDataArray = [];
        document.querySelectorAll(selectors.component).forEach((insuranceComponent) => {
            const componentBasketId = insuranceComponent.getAttribute('data-basket-line-id');
            if (componentBasketId !== basketLineId) {
                return;
            }
            const chosenInsuranceRadio = findChosenInsuranceRadio(insuranceComponent);
            if (chosenInsuranceRadio && chosenInsuranceRadio.value !== 'no') {
                return;
            }
            const item = JSON.parse(
                insuranceComponent.getAttribute(DATA_INSURANCE_ITEM)
            );
            itemDataArray.push(item);
        });
        sendData(VIEW_ITEM_LIST_INSURANCE_EVENT, itemDataArray);
    });
};

const triggerUserChoice = (insuranceComponent, radioButton, event) => {
    let item;
    if (radioButton.value === 'no') {
        item = JSON.parse(insuranceComponent.getAttribute(DATA_INSURANCE_ITEM));
        item.insurance_array = [];
    } else {
        item = JSON.parse(radioButton.getAttribute(DATA_INSURANCE_ITEM));
    }
    item && sendData(event, [item]);
};

export const triggerViewItemInsuranceEvent = (insuranceComponent, radioButton) => {
    triggerUserChoice(insuranceComponent, radioButton, VIEW_ITEM_INSURANCE_EVENT);
};

export const triggerUpdateCartEvent = (items) => {
    sendData(UPDATE_CART_EVENT, items);
};

export const triggerUserUnexpectedBehavior = (message) => {
    dataLayer.push({
        event: 'error',
        error_line: '',
        error_message: message,
        error_type: 'customer error',
    });
};

export const triggerRemoveCartEvent = (item) => {
    sendData(REMOVE_CART_EVENT, item);
};

